<template>
  <div
    class="flex h-[32px] w-[200px] select-none items-center
    gap-[12px] rounded-[6px] border border-[--brand-forestgreenlight]
    bg-[--v3-root-surface-section] px-[8px] py-[4px]"
  >
    <Icon
      name="solid-circle"
      class="size-[12px] shrink-0"
      :style="{
        color
      }"
    />
    <span class="v3-body-regular-400-line-height-1.5 truncate text-[--v3-global-textsecondarycolor]">{{ listName }}</span>
    <div v-show="loading">
      <ProgressSpinner class="size-[20px]" />
    </div>
    <div v-show="!loading" class="relative ml-auto">
      <Transition name="up">
        <span v-if="isAdding" class="v3-body-regular-400-line-height-1.5 absolute left-[-4px] block text-[--v3-green-green-700]">+1</span>
      </Transition>
      <span class="v3-body-regular-400-line-height-1.5 text-[--v3-input-field-inputplaceholdertextcolor]">{{ amount }}</span>
    </div>
    <span v-if="isDraggingKeywordInList">
      <Icon class="size-[14px] text-[--v3-green-green-700]" name="check" />
    </span>
  </div>
</template>

<script lang="ts" setup>
import ProgressSpinner from 'primevue/progressspinner';
import { ref, watch } from 'vue';

import Icon from '@/common/components/atoms/Icon';

interface Props {
  amount: number
  color: string
  isDraggingKeywordInList?: boolean
  listName: string
  loading: boolean
}

const props = withDefaults(defineProps<Props>(), {
  isDraggingKeywordInList: false,
});

const isAdding = ref(false);


watch(() => [props.amount, props.loading], ([newAmount], [oldAmount, oldLoading]) => {
  if (oldLoading && newAmount > oldAmount) {
    isAdding.value = true;

    setTimeout(() => {
      isAdding.value = false;
    }, 100);
  }
});
</script>

<style scoped>
/* Add your styles here */
.up-leave-active,
.up-enter-active
{
  transition: all 500ms;
}

.up-enter-from {
  opacity: 0;
}

.up-enter-to {
  opacity: 1;
}

.up-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.up-leave-to {
  opacity: 0.5;
  transform: translateY(-10px)
}
</style>
